import { useAtomValue } from 'jotai'
import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { clientInvoiceAtom } from 'Invoices/atoms/invoiceEditing.atom'
import { useInvoiceDueDateTerms } from 'Invoices/hooks/useInvoiceDueDateTerms'
import {
  resolveInvoiceDueDate,
  type InvoiceDueDateResolution
} from 'Invoices/utils'

export const useResolvedInvoiceDueDate = ():
  | InvoiceDueDateResolution
  | undefined => {
  const clientInvoice = useAtomValue(clientInvoiceAtom)
  const { calculatedFrom } = useInvoiceDueDateTerms()

  const { data: defaultDueDateDays } = useQuery(
    dashboard20240730Client.getMerchantForSequenceAccount,
    undefined,
    { select: data => data?.defaultDueDateDays }
  )

  if (
    !clientInvoice ||
    !calculatedFrom ||
    typeof defaultDueDateDays !== 'number'
  ) {
    return undefined
  }

  return resolveInvoiceDueDate({
    calculatedFrom,
    dueDate: clientInvoice.dueDate,
    dueDatePolicy: clientInvoice.dueDatePolicy,
    paymentTermDays: clientInvoice.paymentTermDays,
    accountingDate: clientInvoice.accountingDate,
    defaultDueDateDays
  })
}
